import {WlRange, WlRangeItem} from "./range.component";

export * from './range.component';
export default WlRangeItem;

customElements.define('wl-range', WlRange);
customElements.define('wl-range-item', WlRangeItem);
